<template>
  <el-row>
    <el-col>
      <el-menu
        :default-active="defaultUrl"
        :router="routerMode"
        class="el-menu-vertical-demo full-height"
        background-color="#141414"
        text-color="#999999"
        active-text-color="#409eff">
        <slot name="trademark"/>
        <slot name="router"/>
      </el-menu>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      routerMode: true,
      // defaultUrl: '/user-management',
      // defaultUrl: this.$route.path,
      menu: this.$route.name ? this.$route.name : 'aaa'
    }
  },
  computed: {
    defaultUrl() {
      let currentPath = ''
      this.$route.path === '/layout' ? currentPath = '/user-management' : currentPath = this.$route.meta[0].url
      return currentPath
    }
  },
  // created() {
  //   debugger
  //   let currentPath = ''
  //   this.$route.path === '/layout' ? currentPath = '/user-management' : currentPath = this.$route.meta[0].url
  //   this.defaultUrl = currentPath
  // },
  beforeUpdate: function() {
    // if (!this.$route.meta[0].url) {
    //   this.defaultUrl = this.$route.path
    // } else {
    //   // const url = this.$route.path.slice(0, this.$route.path.indexOf('/', 1))
    //   // if (url === '/user-management' || url === '/company-management') {
    //   //   this.defaultUrl = this.$route.path.slice(0, this.$route.path.indexOf('/', 1))
    //   // }
    // }
  }
}
</script>

<style scoped>
.full-height {
  height: 100vh;
}

.el-menu {
  overflow: hidden;
  overflow-y: auto;
}
</style>
